import {
  PARTNER_FORM_CHANGE_FIELD,
  PARTNER_SETTINGS_GET_ASYNC,
  PARTNER_SETTINGS_UPDATE_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case PARTNER_FORM_CHANGE_FIELD:
        return {
          ...state,
          data: {
            ...state.data,
            [action.payload.name]: action.payload.value,
          },
        }
      case PARTNER_SETTINGS_GET_ASYNC.INITIATE:
      case PARTNER_SETTINGS_UPDATE_ASYNC.INITIATE:
        return { ...state, error: null, loader: true }
      case PARTNER_SETTINGS_GET_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          error: null,
          loader: false,
        }
      case PARTNER_SETTINGS_UPDATE_ASYNC.SUCCESS:
        return { ...state, error: null, loader: false }
      case PARTNER_SETTINGS_GET_ASYNC.ERROR:
      case PARTNER_SETTINGS_UPDATE_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case PARTNER_SETTINGS_GET_ASYNC.CANCEL:
      case PARTNER_SETTINGS_UPDATE_ASYNC.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
